export enum BatchTableHeaderLabel {
  ID = "ID",
  NAME = "NAME",
  TYPE = "TYPE",
  RECORDS_COUNT = "RECORDS_COUNT",
  CREATED_ON = "CREATED_ON",
  STATUS = "STATUS"
}
